import React, { useContext, useEffect, useState } from 'react';
import Application from '../../StateContext/Application';
import * as XLSX from 'xlsx';
const ExpenditureDetails = () => {
  const statecalls = useContext(Application);
  const { GetExpenditure } = statecalls;
  const [expenditure, setExpenditure] = useState([]);
  const [formData, setFormData] = useState({
    schema: '',
    throughHolding: false,
    project: '',
    agencyAccount: '',
    bankAccount: '',
    expenditureFor: '',
    officeOrderNo: '',
    GRCopy: null,
    sanctionDate: '',
    transactionDate: '',
    availableAmount: '',
    totalAmount: '',
    narration: '',
    voucherNumber: '',
    schemeComponent: '',
    expenseType: '',
    percentage: '',
    componentAmount: '',
  });

  const getDetails = async () => {

    let data = await GetExpenditure();
    console.log("fetched expenditure", data);
    setExpenditure(data);
  };

  useEffect(() => {
    getDetails();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData(prev => ({
      ...prev,
      GRCopy: file
    }));

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      console.log('sheetData', sheetData);

      if (sheetData.length === 0) {
        console.log("Sheet data is empty.");
      }
    };
    reader.readAsBinaryString(file);
  };

  const handleRadioChange = (e) => {
    setFormData({
      ...formData,
      expenseType: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted with data:", formData);
    try {
      const res = await GetExpenditure("insert", formData);
      console.log("Submitted:", res);

      if (res.success) {
        alert('Form submitted successfully!');
        getDetails();
        handleReset();
      } else {
        alert(res.message || 'Failed to submit');
      }

    } catch (err) {
      console.error('Error submitting form:', err);
      alert('Something went wrong. Please try again.');
    }
  };


  const handleReset = () => {
    setFormData({
      schema: '',
      throughHolding: false,
      project: '',
      agencyAccount: '',
      bankAccount: '',
      expenditureFor: '',
      officeOrderNo: '',
      sanctionDate: '',
      transactionDate: '',
      availableAmount: '',
      totalAmount: '',
      narration: '',
      voucherNumber: '',
      schemeComponent: '',
      expenseType: '',
      percentage: '',
      componentAmount: '',
    });
  };

  return (
    <div style={{ backgroundColor: '#F4F7FE', padding: '3rem 6rem', height: '91vh', overflowY: 'auto' }}>
      <div style={{ backgroundColor: 'white', padding: '1rem', borderRadius: '20px' }}>
        <form onSubmit={handleSubmit}>
          <div style={{ background: 'linear-gradient(to bottom, #B2E0F2, #B7D7EA, #B2D1E6, #B2D1E6)', borderRadius: '10px',padding:'10px' }}>
            <h3 style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700',justifyContent:'center',display:'flex'}}>Create Expenditure Details</h3>
          </div>
          <h5 className='mx-3' style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', padding: '10px' }}>Expenditure Header:</h5>

          <div style={{ display: 'grid', gap: '10px',justifyContent:'center' }}>
            <div style={{ display: 'flex' }}>
              <div className="mx-3 my-1" style={{ width: "29rem" }}>
                <label className='mx-2 my-2 form-label'> Schema:<span style={{ color: "red" }}>*</span></label>
                <select className="form-control" id="schema" name="schema" value={formData.schema} onChange={handleChange}>
                  <option value="">Select Schema</option>
                  <option value="schema1">Schema 1</option>
                  <option value="schema2">Schema 2</option>
                  <option value="schema3">Schema 3</option>
                </select>
              </div>
              <div className="mx-3 my-1" style={{ width: "29rem" }}>
                <label className='mx-2 my-2 form-label'>Project:<span style={{ color: "red" }}>*</span></label>
                <input type='text' className="form-control" name="project" value={formData.project} onChange={handleChange} />
              </div>
            </div>
            <div className="form-check mx-5">
              <input type="checkbox" className="form-check-input" id="schemaCheckbox" name="throughHolding" checked={formData.throughHolding} onChange={handleChange} />
              <label className="form-check-label form-label" htmlFor="schemaCheckbox">Through Holding Account</label>
            </div>
            <div style={{ display: 'flex' }}>
              <div className="mx-3" style={{ width: "29rem" }}>
                <label className='mx-2 my-1 form-label'>Agency Account Choice:<span style={{ color: "red" }}>*</span></label>
                <select className="form-control" name="agencyAccount" value={formData.agencyAccount} onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select>
              </div>

              <div className="mx-3 " style={{ width: "29rem" }}>
                <label className='mx-2 my-1 form-label'>Bank Account:<span style={{ color: "red" }}>*</span></label>
                <select className='form-control' name="bankAccount" value={formData.bankAccount} onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                </select>
              </div>
            </div>
          </div>

          <h5 className='mx-3' style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', padding: '10px' }}>Linked Sanctions:</h5>
          <div className='my-3 mx-5' style={{ display: 'grid', gap: '10px' }}>
          <div style={{ display: 'flex' }}>
            <div className="mx-3 my-1" style={{ width: "29rem" }}>
              <label className='mx-2 my-2 form-label'>Expenditure Done For</label>
              <select className="form-control" name="expenditureFor" value={formData.expenditureFor} onChange={handleChange}>
                <option value="">Select</option>
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
            </div>

            <div className="mx-3 my-1" style={{ width: "29rem" }}>
              <label className='mx-2 my-2 form-label'>Letter/Office Order No</label>
              <input className="form-control" type='text' name="officeOrderNo" value={formData.officeOrderNo} onChange={handleChange} />
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div className="mx-3 my-1" style={{ width: "29rem" }}>
              <label className='mx-2 my-1 form-label'>Office Order Letter Attachment (if any):</label>
              <input className='form-control' name='GRCopy' type='file' onChange={handleFileChange} required />
            </div>
            <div className="mx-3 my-1" style={{ width: "29rem" }}>
              <label className='mx-2 my-1 form-label'>Uploaded Sanction Letter: Sanction Date: *</label>
              <input className='form-control' type='date' name="sanctionDate" value={formData.sanctionDate} onChange={handleChange} />
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div className="mx-3 my-1" style={{ width: "29rem" }}>
              <label className='mx-2 my-1 form-label'>Actual Transaction Date</label>
              <input type='date' className='form-control' name="transactionDate" value={formData.transactionDate} onChange={handleChange} />
            </div>

            <div className="mx-3 my-1" style={{ display: 'flex', width: "29rem" }}>
              <div style={{ width: '16rem' }}>
                <label className='mx-2 my-1 form-label'>Total Available Amount</label>
                <input type='text' className='form-control' name="availableAmount" value={formData.availableAmount} onChange={handleChange} />
              </div>
              <div className="mx-3 my-1" style={{ width: "13rem" }}>
                <label className='mx-2 my-1 form-label'>Total Amount</label>
                <input type='text' className='form-control' name="totalAmount" value={formData.totalAmount} onChange={handleChange} />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div className="mx-3 my-1" style={{ width: "29rem" }}>
              <label className='mx-2 my-1 form-label'>Narration</label>
              <input type='text' className='form-control' name="narration" value={formData.narration} onChange={handleChange} />
            </div>
            <div className="mx-3 my-1" style={{ width: "29rem" }}>
              <label className='mx-2 my-1 form-label'>Voucher Number</label>
              <input type='text' className='form-control' name="voucherNumber" value={formData.voucherNumber} onChange={handleChange} />
            </div>
          </div>
          </div>

          <h5 className='mx-3' style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', padding: '10px' }}>Linked Sanctions:</h5>
          <div className='my-3 mx-5' style={{ display: 'grid', gap: '10px' }}>
            <div style={{ display: 'flex' }}>
              <div className="mx-3 my-1" style={{ width: "29rem" }}>
                <label className='mx-2 my-1 form-label'>Scheme Component</label>
                <input type='text' className='form-control' name="schemeComponent" value={formData.schemeComponent} onChange={handleChange} />
              </div>

              <div className="mx-3 my-1" style={{ width: "29rem" }}>
                <label className='mx-2 my-1 form-label'>Expense Type</label>
                <div style={{ display: 'flex', gap: '20px', width: '10rem', justifyContent: 'center', padding: '5px' }}>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                    <input type='radio' name="expenseType" style={{ width: '1rem', height: '1.2rem' }} value="Revenue" checked={formData.expenseType === 'Revenue'} onChange={handleRadioChange} />
                    <p className='form-label' style={{ margin: '0px' }}>Revenue</p>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                    <input type='radio' style={{ width: '1rem', height: '1.2rem' }} name="expenseType" value="Capital" checked={formData.expenseType === 'Capital'} onChange={handleRadioChange} />
                    <p className='form-label' style={{ margin: '0px' }}>Capital</p>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className="mx-3 my-1" style={{ width: "29rem" }}>
                <label className='mx-2 my-1 form-label'>Percentage</label>
                <input type='number' className='form-control' name="percentage" value={formData.percentage} onChange={handleChange} />
              </div>

              <div className="mx-3 my-1" style={{ width: "25rem" }}>
                <label className='mx-2 my-1 form-label'>Component Amount</label>
                <input type='number' className='form-control' name="componentAmount" value={formData.componentAmount} onChange={handleChange} />
              </div>
              <div style={{ paddingTop: '2rem' }}>
                <button style={{ width: '4rem', height: '2rem', backgroundColor: '#009245', borderRadius: '20px', fontSize: '14px' }}>Add</button>
              </div>
            </div>
          </div>
          <div className='mx-3 my-3'>
            <h6 >Total Amount:</h6>
            <h6>Component Amount:</h6>
            <h6>Balance Amount:</h6>
          </div>
        </form>

      </div>
      <div className='mx-3 my-3' style={{ display: 'flex', gap: '10px',justifyContent:'center'}}>
            <button type="submit" style={{display:'flex',alignItems:'center',width:'5rem',height:'2rem',borderRadius:'20px', background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)',fontSize:'15px',alignItems:'center',justifyContent:'center'}}>Submit</button>
            <button type="button" onClick={handleReset} style={{display:'flex',alignItems:'center',width:'5rem',height:'2rem',borderRadius:'20px', fontSize:'15px',alignItems:'center',justifyContent:'center',border:'2px solid red',color:'red'}}>Reset</button>
          </div>
    </div>
  );
};

export default ExpenditureDetails;
